export default __webpack_public_path__ + "static/media/filterIcon.10377df3.svg";